<template>
	<div>
		<van-nav-bar @click-left="onClickLeft" title="我的消息" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<van-cell-group v-for="item in messageLists" :key="item.id" inset>
			<van-cell  :title="item.sourceTypeName" :value="item.pubTimeString" :label="item.content" />
		</van-cell-group>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
	data() {
		return {
			active: 2,
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
			pageNumber: 1,
			pageSize: 10,
			sourceType: "035001",
			messageLists: [],
            pubTimeString:""
		};
	},
	methods: {
		onClickLeft() {
			this.$router.go(-1);
		},
		messageList() {
			let pageSize = this.pageSize;
			let pageNumber = this.pageNumber;
			let sourceType = this.sourceType;
			let params = {};
			params.pageSize = pageSize;
			params.pageNumber = pageNumber;
			params.sourceType = sourceType;
			this.$axiosPackag.getMessageByAxios("GET", "/foreground/systemMessage/getList", params, null, null, (resD) => {
				this.messageLists = resD.rows;
			});
		},
	},
	created() {
		this.messageList();
	},
};
</script>

<style scoped>
.van-cell__left-icon img {
	width: 1.173333rem;
	height: 1.173333rem;
	margin-right: 0.266667rem;
}
</style>


// WEBPACK FOOTER //
// MobileNewsMore.vue?a213b88a